/**
 * Reads the computed volume discount tiers off a cart product's purchased
 * entity. Returns a plain array (empty when the product has no tiers) so
 * callers can safely use array methods and `.length`.
 *
 * @param {object} product - An immutable cart product entity.
 * @returns {Array} The discount tiers, or an empty array.
 */
export const getProductDiscountTiers = (product) => {
  const tiers = product?.getIn([
    'relationships',
    'purchased_entity',
    'attributes',
    'volume_discount_tiers',
    'value',
  ]);

  return tiers ? tiers.toJS() : [];
};
